import { put, call, all, takeLatest } from 'redux-saga/effects';
import axiosConfig from './axiosConfig';
import {
  fetchSparesDashBoardListSuccess,
  fetchSparesDashBoardListFailure,
  fetchsparesEuipTypeListSuccess,
  fetchsparesEuipTypeListFailure,
  fetchsparesEuipSNListSuccess,
  fetchsparesEuipSNListFailure,
  fetchSapKitNoListListSuccess,
  fetchSapKitNoListListFailure,
  fetchSapNoListListSuccess,
  fetchSapNoListListFailure,
  addSpareKitFailure,
  fetchEuipSNListSuccess,
  fetchEuipSNListFailure,
  fetchExcelSparesDashBoardListSuccess,
  fetchExcelSparesDashBoardListFailure,
  fetchSubcategoryListSuccess,
  fetchSubcategoryListFailure,
} from './action';
import {
  FETCH_SPARES_LIST,
  UPDATE_DASHBOARD_SPARE,
  DELETE_DASHBOARD_SPARE,
  FETCH_SPARE_EQUIPTYPE_LIST,
  FETCH_SPARE_EQUIPSN_LIST,
  FETCH_SPARE_SAPKITN_LIST,
  ADD_SPARE_KIT,
  FETCH_SPARE_SAPNO_LIST,
  ADD_SPARE_INDV,
  PUBLISH_DASHBOARD_LIST,
  FETCH_EQUIPSN_LIST,
  FETCH_EXCEL_SPARES_LIST,
  FETCH_SPARE_SUBCATEGORY_LIST,
} from './types';
import get from 'lodash/get';
import { notification } from 'antd';
import axios from 'axios';

/** Get all spares Admin data Data */
function* fetchSparesDashBoardList({
  projectId,
  pageNumber,
  pageSize,
  equipmentType,
  assignedToSerialNumber,
  subCategory,
  sapKitNo,
  sapNumber,
  description,
  unit,
  safteyStock,
  cost,
}) {
  try {
    let url = `/project-spare-parts?projectId=${projectId}`;
    if (equipmentType) {
      if (Array.isArray(equipmentType)) {
        const sortParam = JSON.stringify(equipmentType);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&equipmentType=${equipmentType}`;
      }
    }
    if (assignedToSerialNumber) {
      if (Array.isArray(assignedToSerialNumber)) {
        const sortParam = JSON.stringify(assignedToSerialNumber);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&assignedToSerialNumber=${assignedToSerialNumber}`;
      }
    }
    if (subCategory) {
      if (Array.isArray(subCategory)) {
        const sortParam = JSON.stringify(subCategory);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&subCategory=${subCategory}`;
      }
    }
    if (sapKitNo) {
      if (Array.isArray(sapKitNo)) {
        const sortParam = JSON.stringify(sapKitNo);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&sapKitNo=${sapKitNo}`;
      }
    }
    if (sapNumber) {
      if (Array.isArray(sapNumber)) {
        const sortParam = JSON.stringify(sapNumber);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&sapNumber=${sapNumber}`;
      }
    }
    if (description) {
      if (Array.isArray(description)) {
        const sortParam = JSON.stringify(description);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&description=${encodeURIComponent(description)}`;
      }
    }
    if (unit) {
      if (Array.isArray(unit)) {
        const sortParam = JSON.stringify(unit);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&unit=${unit}`;
      }
    }
    if (safteyStock) {
      if (Array.isArray(safteyStock)) {
        const sortParam = JSON.stringify(safteyStock);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&safteyStock=${safteyStock}`;
      }
    }
    if (cost) {
      if (Array.isArray(cost)) {
        const sortParam = JSON.stringify(cost);
        url += `&sort=${encodeURIComponent(sortParam)}`;
      } else {
        url += `&cost=${cost}`;
      }
    }
    if (pageNumber && pageSize) {
      sessionStorage.setItem("pageNumberSpare", pageNumber);
      sessionStorage.setItem("pageSizeSpare", pageSize);
      url += `&pageSize=${pageSize}&pageNumber=${pageNumber}`;
    }
    const res = yield axiosConfig.get(url);
    const response = get(res, ["data", "data"], {});
    if (res.status === 200) {
      yield put(fetchSparesDashBoardListSuccess({ response }));
    } else {
      yield put(fetchSparesDashBoardListFailure());
      notification.error({
        message: "Something went wrong. Please try again.",
      });
    }
  } catch (error) {
    yield put(fetchSparesDashBoardListFailure());
    notification.destroy();
    notification.error({
      message: "A problem occured while fetching spares master list.",
      description: `${error.error}`,
    });
  }
}

/** Get all Excel spares Admin data Data */
function* fetchExcelSparesDashBoardList({ projectId }) {
  try {
    let url = `/project-spare-parts?projectId=${projectId}`;
    const res = yield axiosConfig.get(url);
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchExcelSparesDashBoardListSuccess({ response }));
    } else {
      yield put(fetchExcelSparesDashBoardListFailure());
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    yield put(fetchExcelSparesDashBoardListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching spares master list.',
      description: `${error.error}`,
    });
  }
}

/** Get all spares euipment Type list */
function* fetchsparesEuipTypeList() {
  try {
    const res = yield axiosConfig.get(
      `/spare-part-master/column-distinct-values?requiredAttributes=equipmentType`
    );
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchsparesEuipTypeListSuccess({ response }));
    } else {
      yield put(fetchsparesEuipTypeListFailure());
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    yield put(fetchsparesEuipTypeListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching equipment List.',
      description: `${error.error}`,
    });
  }
}

/** Get all spares euipment serial Number list */
function* fetchsparesEuipSNList({ pihEquipmentType }) {
  try {
    const res = yield axiosConfig.get(
      `/spare-part-master/column-distinct-values?requiredAttributes=equipmentSerialNumber&equipmentType=${pihEquipmentType}`
    );
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchsparesEuipSNListSuccess({ response }));
    } else {
      yield put(fetchsparesEuipSNListFailure());
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    yield put(fetchsparesEuipSNListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching equipment serial No.',
      description: `${error.error}`,
    });
  }
}

/** Get all euipment serial Number list for assign to field */
function* fetchEuipSNList({ projectId }) {
  try {
    const res = yield axiosConfig.get(`/pih-equipment/serial-numbers?projectId=${projectId}`);
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchEuipSNListSuccess({ response }));
    } else {
      yield put(fetchsparesEuipSNListFailure());
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    yield put(fetchEuipSNListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching equipment serial No.',
      description: `${error.error}`,
    });
  }
}

/** Get all spares category list */
function* fetchSubcategory({ pihEquipmentType, pihEquipmentSubcategory }) {
  try {
    const res = yield axiosConfig.get(
      `/spare-part-master/column-distinct-values?requiredAttributes=${pihEquipmentSubcategory}&equipmentType=${pihEquipmentType}`
    );
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchSubcategoryListSuccess({ response }));
    } else {
      yield put(fetchSubcategoryListFailure());
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    yield put(fetchSubcategoryListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching Subcategory',
      description: `${error.error}`,
    });
  }
}

/** Get all spares euipment sap kit Number list */
function* fetchSapKitNoList({ sapSparesKitNumber, pihEquipmentType }) {
  try {
    const res = yield axiosConfig.get(
      `/spare-part-master/column-distinct-values?requiredAttributes=${sapSparesKitNumber}&equipmentType=${pihEquipmentType}`
    );
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchSapKitNoListListSuccess({ response }));
    } else {
      yield put(fetchSapKitNoListListFailure());
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    yield put(fetchSapKitNoListListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching Sap kit No.',
      description: `${error.error}`,
    });
  }
}

/** Get all spares euipment sap Number list */
function* fetchSapNoList({
  partSapNumber,
  pihEquipmentType,
  pihEquipmentSn,
  pihEquipmentSapKitNo,
}) {
  try {
    const res = yield axiosConfig.get(
      `/spare-part-master/column-distinct-values?requiredAttributes=${partSapNumber}&equipmentType=${pihEquipmentType}&sapSparesKitNumber=${pihEquipmentSapKitNo}`
    );
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchSapNoListListSuccess({ response }));
    } else {
      yield put(fetchSapNoListListFailure());
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    yield put(fetchSapNoListListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching Sap Number.',
      description: `${error.error}`,
    });
  }
}

// Add Individual Spare
function* addIndvSpare({ payload, selectedProject }) {
  console.log('addIndvSpare', payload);
  try {
    const res = yield axiosConfig.post(`/project-spare-part/assign-individual-spare`, payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield fetchSparesDashBoardList({ projectId: selectedProject.id });
      yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      notification.success({
        message: `Data Added Successfully.`,
      });
      console.log('Data Added Successfully.');
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield fetchSparesDashBoardList({ projectId: selectedProject.id });
    yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the spare kit.',
      description: `${error.error}`,
    });
  }
}

// Add Spare Kit
function* addSpareKit({ payload, selectedProject }) {
  try {
    const res = yield axiosConfig.post(`/project-spare-part/assign-spare-kit`, payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield fetchSparesDashBoardList({ projectId: selectedProject.id });
      yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      notification.success({
        message: `Data Added Successfully.`,
      });
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield fetchSparesDashBoardList({ projectId: selectedProject.id });
    yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the spare kit.',
      description: `${error.error}`,
    });
  }
}

/** Function to update Dashboard Spare data list */
function* updateDashboardSpare({ data, selectedProject }) {
  try {
    const res = yield axiosConfig.put(`/project-spare-part`, data);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield fetchSparesDashBoardList({ projectId: selectedProject.id });
      yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      notification.success({
        message: 'Spare Updated Successfully.',
      });
    } else {
      yield fetchSparesDashBoardList({ projectId: selectedProject.id });
      yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      notification.error({
        message: 'Something went wrong. Please try again later',
      });
    }
  } catch (error) {
    yield fetchSparesDashBoardList({ projectId: selectedProject.id });
    yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
    notification.destroy();
    notification.error({
      message: 'Spare data Updation Failed.',
      description: `${error.error}`,
    });
  }
}

/** Function to publish Dashboard Spare data list */
function* publishDashboardList({ selectedProject }) {
  try {
    const res = yield axiosConfig.put(`/project-spare-parts/publish`, {
      projectId: selectedProject.id,
    });
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield fetchSparesDashBoardList({ projectId: selectedProject.id });
      yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      notification.success({
        message: 'Spare List Published Successfully.',
      });
    } else {
      yield fetchSparesDashBoardList({ projectId: selectedProject.id });
      yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      notification.error({
        message: 'Something went wrong. Please try again later',
      });
    }
  } catch (error) {
    yield fetchSparesDashBoardList({ projectId: selectedProject.id });
    yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
    notification.destroy();
    notification.error({
      message: 'Spare data Updation Failed.',
      description: `${error.error}`,
    });
  }
}

/** Function to delete Dashboard spare data list */
function* deleteDashboardSpare({ id, selectedProject }) {
  try {
    const res = yield axiosConfig.delete(`/project-spare-part/${id}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield fetchSparesDashBoardList({ projectId: selectedProject.id });
      yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      notification.success({
        message: 'Data Deleted Successfully.',
      });
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    notification.destroy();
    yield fetchSparesDashBoardList({ projectId: selectedProject.id });
    yield fetchExcelSparesDashBoardList({ projectId: selectedProject.id });
    notification.error({
      message: 'Data Deletion Failed.',
      description: `${error.error}`,
    });
  }
}

function* SpareDashBoardWatcher() {
  yield takeLatest(FETCH_SPARES_LIST, fetchSparesDashBoardList);
  yield takeLatest(FETCH_EXCEL_SPARES_LIST, fetchExcelSparesDashBoardList);
  yield takeLatest(FETCH_SPARE_EQUIPTYPE_LIST, fetchsparesEuipTypeList);
  yield takeLatest(FETCH_SPARE_EQUIPSN_LIST, fetchsparesEuipSNList);
  yield takeLatest(FETCH_EQUIPSN_LIST, fetchEuipSNList);
  yield takeLatest(FETCH_SPARE_SUBCATEGORY_LIST, fetchSubcategory);
  yield takeLatest(FETCH_SPARE_SAPKITN_LIST, fetchSapKitNoList);
  yield takeLatest(ADD_SPARE_INDV, addIndvSpare);
  yield takeLatest(ADD_SPARE_KIT, addSpareKit);
  yield takeLatest(FETCH_SPARE_SAPNO_LIST, fetchSapNoList);
  yield takeLatest(UPDATE_DASHBOARD_SPARE, updateDashboardSpare);
  yield takeLatest(PUBLISH_DASHBOARD_LIST, publishDashboardList);
  yield takeLatest(DELETE_DASHBOARD_SPARE, deleteDashboardSpare);
}

function* spareDashBoardSagas() {
  yield all([call(SpareDashBoardWatcher)]);
}

export default spareDashBoardSagas;

/** Get all spares euipment Type list */
export const OnGetSapNumberList = async () => {
  try {
    const res = await axiosConfig.get(
      `/spare-part-master/column-distinct-values?requiredAttributes=partSapNumber`
    );
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      console.log('Data_List', response);
      return response;
    } else {
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching equipment List.',
      description: `${error.error}`,
    });
  }
};

/** Get all spares euipment Type list */
export const OnGetSparesItem = async (sapNumber) => {
  console.log(sapNumber);
  try {
    // const sortParam = JSON.stringify(partSapNumber);
    // url = `/spare-part-masters?sort=${encodeURIComponent(sortParam)}`;
    const res = await axiosConfig.get(`/spare-part-masters?partSapNumber=${sapNumber}`);
    // const res = await axiosConfig.get(url);
    console.log(res);
    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      console.log('Data_List', response);
      return response;
    } else {
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching equipment List.',
      description: `${error.error}`,
    });
  }
};

/** Function to Add new Document Type */
export const onUploadSparesExcel = async (payload, projectId) => {
  try {
    if (payload?.certificate) {
      const resFile = await axiosConfig.get(
        `/spare-part-masters/upload/presigned-url?fileName=${payload.certificate[0].name}&contentType=${payload.certificate[0].type}`
      );
      const responseFile = get(resFile, ['data', 'data'], {});
      console.log('excel response', responseFile);
      if (responseFile && responseFile.presignedUrl) {
        // Dispatch the presigned URL with the file to AWS server
        const presignedResponse = await axios.put(
          responseFile.presignedUrl,
          payload.certificate[0]
        );
        console.log('excel response 1', presignedResponse);
        if (presignedResponse.status === 200) {
          payload.fileKey = responseFile.fileKey;
        } else {
          notification.error({ message: 'File Uploading Failed. Please try again.' });

          return;
        }
      } else {
        notification.error({ message: 'File Uploading Failed. Please try again.' });

        return;
      }
    }
    const res = await axiosConfig.post(`/project-spare-part/assign-individual-spare/upload`, {
      fileKey: payload.fileKey,
      projectId: projectId,
    });
    const response = get(res, ['data', 'data'], {});
    notification.destroy();

    if (res.status === 200) {
      notification.success({
        message: 'File  Uploaded Successfully.',
      });
      return true;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    console.log(error);

    notification.destroy();
    notification.error({
      message: 'A problem occurred while uploading the file',
      description: `${error.error}`,
    });
  }
};